export async function loadBranding() {
  try {
    const res = await fetch('/config/branding.json', { cache: 'no-cache' });
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (_) {
    return null;
  }
}


